import 'jquery';
import AbstractController from './AbstractController';
import Controller from './Controller';
import { $window, $html, $body, Breakpoints } from '../Constants';

// Utility
import HelperUtility from '../Utility/HelperUtility';

// Service
import HeadlineService from '../Service/HeadlineService';

// HtmlElements
import Banner from '../Elements/Banner';
import BannerCta from '../Elements/BannerCta';
import Header from '../Elements/Header';
import NavSubHorizontal from '../Elements/NavSubHorizontal';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import Form from '../Elements/Form';
import CtaBar from '../Elements/CtaBar';
import NavMain from '../Elements/NavMain';
import MetaBar from '../Elements/MetaBar';
import Main from '../Elements/Main';
import BigImageText from '../Elements/BigImageText';
import TextAnimation from '../Elements/TextAnimation';
import CtaSwap from '../Elements/CtaSwap';
import Facts from '../Elements/Facts';
import ImageWithBoxSlider from '../Elements/ImageWithBoxSlider';
import Tabs from '../Elements/Tabs';
import ScrollingText from '../Elements/ScrollingText';
import VideoTestimonials from '../Elements/VideoTestimonials';
import MediaText from '../Elements/MediaText';
import RegionSelector from '../Elements/RegionSelector';
import SocialProof from '../Elements/SocialProof';
import { ResizeObserver } from '../ResizeObserver';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 *
 * @class
 */
class PageController extends AbstractController {

	/**
	 * @constructor
	 */
	constructor() {
		super();

		// Only do this for hostname www.topfit.fitness and path should not start with "/pt/"
		let allowedHostnames = ['www.topfit.fitness', 'topfit-v12.ddev.site', 'p640629.mw.igroupweb.de'];
		if (allowedHostnames.includes(window.location.hostname) && !window.location.pathname.startsWith('/pt/')) {
			this._fetchOfferEntryForMenu();
		}

		Controller.registerController(this);

		// Handle "auto" animated cross side
		$('.animated-cross').each((i, el) => {
			if ($(el).data('side') === 'auto') {
				let side = 'left';
				const prevIndex = i - 1;

				if (prevIndex > -1) {
					const $prev = $('.animated-cross').eq(prevIndex);
					if ($prev.length && $prev.attr('data-side') === 'left') {
						side = 'right';
					}
				}

				$(el).attr('data-side', side);
			}
		});

		// Object containing special elements that inherit from HtmlElement
		// relevant page events are delegated to these objects through the controller
		this._registerElements(
			Banner,
			BannerCta,
			Header,
			NavSubHorizontal,
			BackToTopButton,
			...ContentSlider,
			...Form,
			CtaBar,
			NavMain,
			MetaBar,
			...Main,
			...BigImageText,
			...TextAnimation,
			...CtaSwap,
			...Facts,
			...ImageWithBoxSlider,
			...Tabs,
			...ScrollingText,
			...VideoTestimonials,
			...MediaText,
			...RegionSelector,
			...SocialProof
		);

		// Initialize HeadlineService
		HeadlineService.initialize();
	}

	// Private

	/**
	 * Adds the javascript for accordions
	 *
	 * @return void
	 */
	_addAccordionJavascript() {
		$('[data-accordion]').each((i, el) => {
			let $accordion = $(el),
				$bigImageText = $accordion.parents('.big-image-text');

			if ($bigImageText.length > 0) {
				let $equalizedRow = $bigImageText.find('> .row'),
					$columns = $equalizedRow.find('> .columns[data-equalizer-watch]');

                $columns.each((i, el) => {
                    let $column = $(el),
                        equalizedHeight = $column.outerHeight();

                    $column.data('equalized-height', equalizedHeight);
                });

				$accordion.on('up.zf.accordion', () => {
                    $columns.each((i, el) => {
                        let $column = $(el);

                        $column.css({
							'height': $column.data('equalized-height'),
							'min-height': ''
                        });
                    });
				});

                $accordion.on('down.zf.accordion', () => {
                    $columns.each((i, el) => {
                        let $column = $(el);

                        $column.css({
                            'height': 'auto',
                            'min-height': $column.data('equalized-height')
                        });
                    });
                });

                $accordion.find('.accordion-title').on('click', () => {
                    $columns.each((i, el) => {
                    	let $column = $(el),
							equalizedHeight = $column.data('equalized-height');

                    	$column.css('min-height', '');

                    	if (equalizedHeight > 0) {
                    		$column.css({
								'height': 'auto',
								'min-height': equalizedHeight
							});
						}
					});
                });
			}
		});
	}

	/**
	 * Adds the anchor scrolling functionality
	 *
	 * @return void
	 */
	_addAnchorScrolling() {
		$body.find('[href*="#"]').each((i, el) => {
			try {
				let $element = $(el),
					anchor = $element.get(0).hash;

				if (anchor.length > 1) {
					let $elementToScrollTo = $(anchor);

					if ($elementToScrollTo.length === 1) {
						$element.on('click', (e) => {
							if (el.pathname === window.location.pathname) {
								e.preventDefault();
								this._scrollToElement($elementToScrollTo);
							}
						});
					}
				}
			} catch (error) {

			}
		});
	}

	/**
	 * Scrolls the viewport to the given element
	 *
	 * @param { jQuery } $element
	 * @return void
	 */
	_scrollToElement($element) {
		let offset = $element.offset().top;

		if ($window.width() >= Breakpoints.LARGE) {
			if (Header.exists()) {
				offset = offset - Header.getHeight();
			}

			if (NavSubHorizontal.exists()) {
				offset = offset - NavSubHorizontal.getHeight();
			}
		}

		$('html, body').animate({
			scrollTop: offset
		});
	}

	/**
	 * Scrolls automatically to the anchor of the current URL if given and valid
	 *
	 * @return void
	 */
	_scrollToCurrentAnchor() {
		let anchor = window.location.hash;

		if (anchor) {
			let $elementToScrollTo = $(anchor);
			if ($elementToScrollTo.length === 1) {
				$('html, body').animate({
					scrollTop: 0
				}, 0);

				this._scrollToElement($elementToScrollTo);
			}
		}
	}

	_initializeMarkerEffect() {
		const callback = (entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('active');
					observer.unobserve(entry.target);
				}
			});
		};

		const observer = new IntersectionObserver(callback);

		document.querySelectorAll('.main, .big-image-text, .campaign').forEach((section) => {
			section.querySelectorAll('.highlight').forEach((el, i) => {
				$(el).css('--delay', `${0.4 * (i + 1)}s`);
				observer.observe(el);
			});
		});
	}

	_setBigImageTextPadding() {
		const $firstBigImageText = $body.find('.banner ~ main > .frame:first-child > .big-image-text');
		const $firstSection = $body.find('.banner ~ main > .frame:first-child > section');
		const $bannerCta = $body.find('.banner-cta');
		if((!$firstBigImageText.length && !$firstSection.length) || !$bannerCta.length) return;

		let paddingTop = 0;

		const setSectionPadding = () => {
			if ($firstBigImageText.length) {
				$firstBigImageText.css('padding-top', paddingTop > 0 ? paddingTop : '');
			} else {
				$firstSection.css('padding-top', '');
				const currentPadding = parseFloat(getComputedStyle($firstSection.get(0)).getPropertyValue('padding-top'));
				$firstSection.css('padding-top', paddingTop > 0 ? paddingTop + currentPadding : '');
			}
		};

		if ($window.width() >= Breakpoints.LARGE) {
			paddingTop = $bannerCta.outerHeight() / 2;
		} else {
			paddingTop = 0;
		}

		setSectionPadding();

		$window.on('resize', () => {
			if ($window.width() >= Breakpoints.LARGE) {
				paddingTop = $bannerCta.outerHeight() / 2;
			} else {
				paddingTop = 0;
			}

			setSectionPadding();
		});
	}

	/**
	 * Fetches offer menu item with ajax
	 * This way, the translations can stay cached if the offer changes
	 *
	 * @return void
	 */
	_fetchOfferEntryForMenu() {
		$.ajax({
			url: window.location.origin,
			type: 'GET',
			data: {
				type: 5910
			},
			success: (data) => {
				const $result = $(data);
				if ($result.length) {
					$('.menu-main-items > ul.level-1').append($result);
				}
			}
		});
	}

	// Public

	/**
	 * Handles ready event
	 *
	 * @return void
	 */
	onReady() {
		super.onReady();

		$html.attr('data-touch-device', HelperUtility.isTouchDevice());

		if (!HelperUtility.supportsCssFilter()) {
			$html.addClass('no-css-filter');
		}

		this._addAccordionJavascript();
		this._addAnchorScrolling();
		this.checkRowsContainsBox();
		this._initializeMarkerEffect();
		this._setBigImageTextPadding();

		let subNavHeight = 0;
		if (NavSubHorizontal.exists()) {
			subNavHeight = NavSubHorizontal.getHeight();
		}

		$('body').css('--sub-nav-height', `${subNavHeight}px`)

		if (Header.exists()) {
			const observer = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					$('body').css('--header-height', `${entry.target.clientHeight}px`)
				});
			});

			observer.observe(Header.$element.get(0));
		}

		document.querySelectorAll('form').forEach((form) => {
			form.addEventListener('submit', (e) => {
				form.querySelectorAll('[type="submit"]').forEach((button) => {
					button.disabled = true;
				});
			});
		});

		let shortcutsHeight = 0;
		const $shortcuts = $('.tx-ig-shortcuts');

		if ($shortcuts.length) {
			shortcutsHeight = $shortcuts.outerHeight();
			$('body').css('--shortcuts-height', `${shortcutsHeight}px`)
		}

		const currentTitle = document.title;
		let titleTimeout = null;
		document.addEventListener('visibilitychange', (event) => {
			if (titleTimeout) {
				clearTimeout(titleTimeout);
			}

			let exitTitle = $html.data('exittitle');

			if (document.visibilityState === 'visible' || exitTitle === undefined || exitTitle === '') {
				document.title = currentTitle;
			} else {
				titleTimeout = setTimeout(() => {
					document.title = exitTitle;
				}, 500);
			}
		});
	}

	/**
	 * Handles load event
	 *
	 * @return void
	 */
	onLoad() {
		this._scrollToCurrentAnchor();
	}

	/**
	 * Checks if equalized rows contain boxes
	 *
	 * @return void
	 */
	checkRowsContainsBox() {
		let $rows = $('.row');

		$rows.each((i, el) => {
			let $row = $(el),
				$columns = $row.find('> .columns');

			$columns.each((i, el) => {
				let $box = $(el).find('.box');

				if ($box.length === 1 && $(el).find('> .frame').not($box.parent()).length < 1) {
					$(el).addClass('contains-box');
				}
			});
		});
	}
}

export default (new PageController);
